import * as Sentry from '@sentry/react';
import { SeverityLevel } from '@sentry/browser';

export const initializeSentry = () => {
    Sentry.init({
        dsn: 'https://86a9dbe092d30a15ef2c009e081f7d7c@o4510721070727168.ingest.us.sentry.io/4510721077215232',
        // Casa com o release usado no upload de source maps (ver vite.config.ts),
        // para que os stack traces resolvam corretamente no Sentry.
        release: __SENTRY_RELEASE__,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: true
            })
        ],
        ignoreErrors: [
            // Ruído de deploy: usuários com bundle antigo em cache tentam
            // pré-carregar chunks cujo hash mudou no novo build. Não é bug real.
            /Unable to preload CSS/i,
            /Failed to fetch dynamically imported module/i,
            /error loading dynamically imported module/i,
            /Importing a module script failed/i
        ],
        tracesSampleRate: 0.05,
        tracePropagationTargets: [
            'app.selenebot.com.br/',
            'novo.selenebot.com.br/'
        ],
        attachStacktrace: false,
        replaysSessionSampleRate: 0.01,
        replaysOnErrorSampleRate: 0.1, 
        sendDefaultPii: true
    });
};

const logToSentry = (
    level: SeverityLevel,
    message: string,
    metadata: unknown = null
) => {
    /*
    if (!shouldSendLogsToSentry()) {
        console.warn(`[Local logging]: ${message}`, metadata);
        return;
    }
        */

    Sentry.withScope(function (scope) {
        scope.setLevel(level);
        if (metadata instanceof Error) {
            Sentry.captureException(metadata, {
                extra: { message: message }
            });
        } else {
            Sentry.captureMessage(message, {
                extra: { metadata }
            });
        }
    });
};

export const info = (message: string, metadata: unknown = null) => {
    logToSentry('debug', message, metadata);
};

export const warn = (message: string, metadata: unknown = null) => {
    logToSentry('warning', message, metadata);
};

export const error = (message: string, metadata: unknown = null) => {
    logToSentry('error', message, metadata);

    // eslint-disable-next-line no-console
    console.error(message);
};
export const critical = (message: string, metadata: unknown = null) => {
    logToSentry('fatal', message, metadata);
};
